import { useBookingContext } from '../BookingContext'
import { Button } from '@w/components/ui/button'
import CalendarPicker from '../components/CalendarPicker'
import TimeSlotPicker from '../components/TimeSlotPicker'
import { ArrowRight, ArrowLeft } from 'lucide-react'

export default function DateTimeStep() {
  const {
    selectedDate,
    selectedTimeSlot,
    goToStep,
    configurationMode,
  } = useBookingContext()

  const canContinue = selectedDate && selectedTimeSlot

  // Configuration mode: Show calendar/time slot pickers in non-functional state
  if (configurationMode) {
    return (
      <div className="max-w-5xl mx-auto space-y-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <CalendarPicker />
          </div>
          <div>
            <TimeSlotPicker />
          </div>
        </div>
        <div className="flex justify-between pt-6 border-t">
          <Button variant="outline" size="lg" disabled className="gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
          <Button size="lg" disabled className="gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    )
  }

  const handleContinue = () => {
    if (!canContinue) return
    goToStep('contact')
  }

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      {/* Two Panel Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Left Panel: Calendar */}
        <div>
          <CalendarPicker />
        </div>

        {/* Right Panel: Time Slots */}
        <div>
          <TimeSlotPicker />
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between pt-6 border-t">
        <Button
          variant="outline"
          size="lg"
          onClick={() => goToStep('service')}
          className="gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Button>
        <Button
          onClick={handleContinue}
          disabled={!canContinue}
          size="lg"
          className="gap-2 px-8"
        >
          Continue to Contact Info
          <ArrowRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  )
}
